import { Component } from '@angular/core'

@Component({
  selector: 'se-po-household-setup-feature-child-info-docs',
  templateUrl: './child-info-docs.component.html',
  styleUrls: ['./child-info-docs.component.scss'],
  standalone: false,
})
export class ChildInfoDocsComponent {
}
